<template>
  <v-row>
    <v-col cols="12">
      <v-text-field v-model="data.name" label="name"></v-text-field>
    </v-col>
    <v-col cols="12">
      <v-textarea
        rows="2"
        v-model="data.description"
        label="description"
      ></v-textarea>
    </v-col>
    <v-col cols="12">
      <select-categories v-model="data.category"> </select-categories>
    </v-col>
  </v-row>
</template>

<script>
import SelectCategories from '../../../components/SelectCategories'
export default {
  name: 'TagForm',
  props: ['data'],

  data() {
    return {}
  },
  components: {
    SelectCategories
  }
}
</script>

<style scoped></style>
